import { useDroppable } from "@dnd-kit/core";

const DroppableZone = ({ id, color, icono, texto, activo }) => {
  const { isOver, setNodeRef } = useDroppable({ id });

  if (!activo) return null;

  return (
    <div
      ref={setNodeRef}
      style={{
        flex: 1,
        height: "80px",
        backgroundColor: isOver ? color : "#ffffff",
        border: `2px dashed ${color}`,
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: isOver ? "#ffffff" : color,
        fontSize: "16px",
        fontWeight: "bold",
        transition: "all 0.2s ease",
        margin: "0 10px",
        cursor: "pointer",
        opacity: isOver ? 1 : 0.7,
        boxShadow: isOver ? `0 0 15px ${color}40` : "none"
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {icono} {texto}
      </div>
    </div>
  );
};

export default DroppableZone